<template>
  <TopNav></TopNav>
  <h1>Percentage Increase Calculator</h1>
  <fieldset>
    <legend>Percentage Increase Calculator</legend>
    <label for="initialValueId">Initial value:</label><input type="number" v-model.number="initialValue" id="initialValueId" step="any" @input="onInitialValueChange"><br>
    <label for="finalValueId">Final Value:</label><input type="number" v-model.number="finalValue" id="finalValueId" step="any" @input="onFinalValueChange"><br>
    <br>
    <label for="increasePercentageId">Increase:</label><input type="number" v-model.number="increasePercentage" id="increasePercentageId" step="any" @input="onIncreasePercentageChange">%<br>
    <label for="differenceValueId">Difference:</label><input type="number" v-model.number="differenceValue" id="differenceValueId" step="any" @input="onDifferenceValueChange">
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "PercentageIncrease",
    data() {
        return {
            initialValue: 50,
            finalValue: 65,
            increasePercentage: 15,
            differenceValue: 30,
        }
    },
  components: {
    TopNav
  },
  methods: {
      onInitialValueChange(e) {
          const initialVal = e.currentTarget.value;
          const initialNumber = Number(initialVal);
          this.increasePercentage = (this.finalValue - initialNumber) / initialNumber * 100;
          this.differenceValue = this.finalValue - initialNumber;
      },
      onFinalValueChange(e) {
          const finalVal = e.currentTarget.value;
          const finalNumber = Number(finalVal);
          this.increasePercentage = (finalNumber - this.initialValue) / this.initialValue * 100;
          this.differenceValue = finalNumber - this.initialValue;
      },
      onIncreasePercentageChange(e) {
          const increasePercentage = e.currentTarget.value;
          const increasePercentageNumber = Number(increasePercentage);
          this.finalValue = this.initialValue + (this.initialValue * increasePercentageNumber) / 100;
          this.differenceValue = this.finalValue - this.initialValue;
      },
      onDifferenceValueChange(e) {
          const differenceValue = e.currentTarget.value;
          const differenceValueNumber = Number(differenceValue);
          this.finalValue = this.initialValue + differenceValueNumber;
          this.increasePercentage = (this.finalValue - this.initialValue) / this.initialValue * 100;
      }
  },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

.result {
    color: #0063dc;
}

label {
    display: inline-block;
    width: 110px;
}

footer section a {
    margin: 20px;
}
</style>
